




























export interface Icon {
  height: number;
  width: number;
}

import Vue from "vue";
import { Messages } from "@/constants/messages";
export default Vue.extend({
  name: "IconUploader",
  data(): {
    file: File | null;
    mess: any;
    iconImage: Icon;
    invalidFile: boolean;
    errorMessage: string;
  } {
    return {
      file: null,
      mess: Messages,
      invalidFile: false,
      errorMessage: "",
      iconImage: {
        height: 0,
        width: 0,
      },
    };
  },
  methods: {
    errorImage(message: string): void {
      this.file = null;
      this.invalidFile = true;
      this.errorMessage = message;
    },
    successValidation() {
      this.invalidFile = false;
      this.errorMessage = "";
      this.$emit("icon", this.file);
    },
    checkDimensions() {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = (res) => {
          let img = new Image();
          img.onload = () => {
            this.iconImage.width = img.width;
            this.iconImage.height = img.height;
            const diff = Math.abs(
              this.iconImage.width / this.iconImage.height - 1
            );
            if (diff > 0.1) {
              resolve(this.mess.error_icon_no_square);
              return;
            }

            resolve("");
          };
          img.src = (res.target as FileReader).result as string;
        };
        reader.onerror = (err) => reject(err);
        if (this.file) {
          reader.readAsDataURL(this.file);
        }
      });
    },
    async checkFile() {
      if (this.file === null) return;
      const validType = this.file.type === "image/png";
      const MAX_SIZE_ICON = 1024 * 1000;
      const validSize = MAX_SIZE_ICON > this.file.size;
      const validDimensions = false;
      if (!validType) {
        this.errorImage(this.mess.error_extension + "PNG");
        return;
      }
      if (!validSize) {
        this.errorImage(this.mess.error_size_big + "1024 KB");
        return;
      }
      if (!validDimensions) {
        const content = await this.checkDimensions();
        if (content !== "") {
          this.errorImage(content as string);
          return;
        }
      }
      this.successValidation();
    },
    validateField(): boolean {
      if (this.file == null) {
        this.invalidFile = true;
        this.errorMessage = "An icon" + this.mess.error_mandatory;
        return false;
      }
      this.invalidFile = false;
      return true;
    },
  },
});
